// Firebase configuration
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, signInAnonymously } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyD6sGb9yyP0km0y7vNZ-7sL4Y0y9NqaNTY",
    authDomain: "codeshare2-8a470.firebaseapp.com",
    projectId: "codeshare2-8a470",
    storageBucket: "codeshare2-8a470.firebasestorage.app",
    messagingSenderId: "844724133326",
    appId: "1:844724133326:web:a9f6c819d396378bdf9f9f",
    measurementId: "G-P84SCL8CLX"
};
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const signInAnonymouslyUser = () => signInAnonymously(auth);
